import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import ProtectedRoute from './components/components/route_protection/protectedRoute.jsx';
import Login from './components/login/login.jsx';
import NotFound from './tables/notFound.jsx';
import Events from './tables/events/events.jsx';
import Promo from './tables/promo/promo.jsx';
import Stats from './tables/stats2/stats.jsx';
import PaymentTest from './tables/payment/paymentTest.jsx';
import GlobalAlert from './components/components/global_alert/GlobalAlert.jsx';

function App() {
  return (
    <Router>
      <GlobalAlert />
      <Routes>
        <Route
          path="/"
          element={<ProtectedRoute Component={Events} LoginComponent={Login} />}
        />
        <Route
          path="/statistics"
          element={<ProtectedRoute Component={Stats} LoginComponent={Login} />}
        />
        <Route
          path="/promo"
          element={<ProtectedRoute Component={Promo} LoginComponent={Login} />}
        />
        <Route
            path="/paymenttest"
            element={<ProtectedRoute Component={PaymentTest} LoginComponent={Login} />}
        />

          <Route
              path="*"
              element={<ProtectedRoute Component={NotFound} LoginComponent={Login} />}
          />
      </Routes>
    </Router>
  );
}

export default App;
